export class PeselValidator  {
    private static format = /^[0-9]{11}$/;
    private static weights = [1, 3, 7, 9];

    public static isValid(pesel: string): boolean {
        if (!pesel) {
            return true;
        }

        if (!PeselValidator.format.test(pesel)) {
            return false;
        }

        let sum = 0;

        for (let i = 0; i < pesel.length - 1; ++i) {
            sum = (sum + this.weights[i % 4] * Number(pesel[i])) % 10;
        }

        const checksum = (10 - sum) % 10;
        const peselChecksum = Number(pesel[pesel.length - 1]);

        return checksum === peselChecksum;
    }
}
